import { Avatar, Box, CircularProgress, MenuItem, Select, Typography } from "@mui/material";
import style from "./styles";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import TransactionDetails from "../../../components/TransactionDetails";
import ButtonOutlinedCentered from "../../../components/ButtonOutlined";
import GroupIcon from "../../../components/GreenCity/GroupIconImage"
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { T, TF } from "react-translator-component";
import appServices from "../../../services/app-services/appServices";
import { convertUserImage } from "../../../util/utils";

const PaymentHistory = () => {
  const { user } = useSelector((state: any) => state.userAuth);
  const navigate = useNavigate();
  const location = useLocation();
  const { groupId } = location.state || {}
  const targetId = groupId || user.id
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const [selectedYear, setSelectedYear] = useState<string>(currentYear.toString());
  const [selectedMonth, setSelectedMonth] = useState<string>(currentMonth.toString());
  const years = Array.from({ length: 50 }, (_, i) => 2024 + i);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const dropdownOptions = ["all", "income", "expense"];
  const [selectedOption, setSelectedOption] = useState<string>(`${T("all")}`);

  const handleOptions = (type: string) => {
    switch (type) {
      case "all":
        return `${T("all")}`
      case "income":
        return `${T("payment_income")}`
      case "expense":
        return `${T("payment_expense")}`
      default:
        return `${T("all")}`
    }
  }

  const handleAPICall = async () => {
    setLoading(true);
    try {
      const res = groupId ?
        await appServices.getPaymentInfo("MemberGroup", groupId, selectedYear, selectedMonth) :
        await appServices.getPaymentInfo("User", user.id, selectedYear, selectedMonth)
      setPayments(res.payments);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const showAdd = (item: any) => {
    return item.payee.id === targetId;
  };

  const filterData = () => {
    if (selectedOption === `${T("all")}`) {
      return payments;
    } else if (selectedOption === `${T("payment_income")}`) {
      return payments.filter((item: any) => item.payee.id === targetId);
    } else if (selectedOption === `${T("payment_expense")}`) {
      return payments.filter((item: any) => item.payee.id !== targetId);
    }
  };

  useEffect(() => {
    handleAPICall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigateGroupLeader = () => {
    navigate("/groupleader", {
      state: {
        groupId: groupId,
      },
    });
  }

  const handleNavigateGoback = () => {
    groupId ? handleNavigateGroupLeader() : navigate(-1)
  }

  return (
    <Box>
      <Box sx={style.headerBox}>
        <GCBackButton onClick={() => handleNavigateGoback()} />
        <Box sx={style.rowMargin}>
          {groupId ?
            <GroupIcon groupId={groupId} style={{ ...style.avatar, width: "30px" }} /> :
            <Avatar src={convertUserImage(user.image)} sx={{ ...style.avatar, width: "30px" }} />
          }
          <Typography>{T("payment_history")}</Typography>
        </Box>
      </Box>
      <Box sx={style.container}>
        <Typography sx={style.titleSeprator}>{T("payment_payment_month")}</Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} displayEmpty sx={{ width: "33%", backgroundColor: "white", height: "40px" }}>
            <MenuItem value="" disabled>
              {TF("{0} {1}", selectedYear, T("year"))}
            </MenuItem>
            {years.map((yr) => (
              <MenuItem key={yr} value={yr}>
                {yr}
              </MenuItem>
            ))}
          </Select>
          <Select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} displayEmpty sx={{ width: "30%", backgroundColor: "white", height: "40px" }}>
            <MenuItem value="" disabled>
              {TF("{0} {1}", selectedMonth, T("month"))}
            </MenuItem>
            {months.map((mn) => (
              <MenuItem key={mn} value={mn}>
                {mn}
              </MenuItem>
            ))}
          </Select>

          <ButtonOutlinedCentered onClick={() => handleAPICall()} title={T("display")} />
        </Box>
        <Select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)} displayEmpty sx={{ height: "40px", width: "100%", marginTop: "10px" }}>
          {dropdownOptions.map((mn) => (
            <MenuItem key={mn} value={handleOptions(mn)}>
              {handleOptions(mn)}
            </MenuItem>
          ))}
        </Select>

        {!loading ? (
          filterData()?.map((item: any, index: number) => (
            <Box sx={{ marginTop: "20px" }} key={index}>
              <TransactionDetails payment={item} isAdd={showAdd(item)}/>
            </Box>
          ))
        ) : (
          <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
            <CircularProgress size={30} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PaymentHistory;
